export class Form {
    constructor(categoryOptions, locationOptions) {
        this.categoryOptions = categoryOptions;
        this.locationOptions = locationOptions;
    }

    schema() {
        return [
            {
                'component': 'h2',
                'children': 'Element bearbeiten',
            },
            {
                'component': 'div',
                'class': 'row',
                'children': [
                    {
                        'type': 'text',
                        'name': 'name',
                        'label': 'Name',
                        'class': 'col-12 col-md-8',
                        'placeholder': 'Bitte Namen eingeben...',
                        'validation': 'min:5,length|required',
                        'validation-name': 'Name',
                    },
                    {
                        'type': 'number',
                        'name': 'price',
                        'label': 'Preis',
                        'class': 'col-12 col-md-4',
                        'placeholer': 'Bitte Preis einfügen',
                        'validation': 'optional|number',
                        'validation-name': 'Preis',
                        'step': 0.01,
                    },
                    {
                        'type': 'multiselect',
                        'name': 'category',
                        'label': 'Kategorie',
                        'class': 'col-12 col-md-6',
                        'placeholder': 'Kategorie auswählen...',
                        'validation': 'required',
                        'validation-name': 'Kategorie',
                        'options': this.categoryOptions,
                    },
                    {
                        'type': 'multiselect',
                        'name': 'state',
                        'label': 'Bundesland',
                        'class': 'col-12 col-md-6',
                        'placeholder': 'Bundesland auswählen...',
                        'validation': 'required',
                        'validation-name': 'Bundesland',
                        'options': this.locationOptions,
                    },
                    {
                        'type': 'date',
                        'name': 'visible_from',
                        'label': 'Sichtbar ab',
                        'class': 'col-12 col-md-6',
                        'validation': 'optional|date',
                        'validation-name': 'Sichtbarkeit von ',
                        'help': 'Hier können Sie festlegen ab welchem Tag das Produkt für Ihre Kunden sichtbar ist. Ist das Feld leer, dann wird das Produkt sofort dargestellt.',
                    },
                    {
                        'type': 'date',
                        'name': 'visible_to',
                        'label': 'Sichtbar bis',
                        'class': 'col-12 col-md-6',
                        'validation': 'optional|date',
                        'validation-name': 'Sichtbarkeit bis ',
                        'help': 'Ist das Feld leer, dann bleibt das Produkt sichtbar.',
                    },
                    {
                        'type': 'text',
                        'name': 'manufacturer',
                        'label': 'Hersteller',
                        'class': 'col-12 col-md-6',
                        'placeholder': 'Hersteller ...',
                        'validation': 'required',
                        'validation-name': 'Hersteller',
                    },
                    {
                        'type': 'text',
                        'name': 'url',
                        'label': 'Hersteller Link',
                        'help': 'Eine valide URL beginnt mit http:// oder https://',
                        'class': 'col-12 col-md-6',
                        'placeholder': 'Hersteller Link',
                        'validation': 'optional|url',
                        'validation-name': 'Hersteller Link',

                    },
                    {
                        'type': 'editor',
                        'name': 'description',
                        'label': 'Beschreibung',
                        'class': 'col-12',
                        'validation': 'required',
                        'validation-name': 'Beschreibung',
                    },
                    {
                        'type': 'cropper',
                        'aspectRatio': 4 / 3,
                        'name': 'media',
                        'label': 'Bild',
                        'class': 'col-12',
                        'uploadBehavior': 'delayed',
                        'validation': 'optional|mime:image/jpeg,image/png',
                        'validation-name': 'Bild',
                        'help': 'Wählen Sie ein PNG oder JPG zum Hochladen aus.',
                    },
                ],
            },
        ];

    }
}
